var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SmoothReflow',[(!_vm.isMobile || _vm.showOnMobile)?_c('nav',{staticClass:"nav"},[_c('ol',_vm._l((_vm.navLinks),function(link,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":link.path,"active-class":"active"}},[_vm._v(_vm._s(link.title))])],1)}),0)]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }